import React, { useEffect, useState } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { dataStatusSelector } from 'redux/selectors';
import LimitedBackdropLoading from 'components/Loading/LimitedBackdropLoading';
import TableError from 'components/Errors/TableError';

import { STATUS } from 'constants/thunkStates';
import { tableLocaleText } from 'config';
import generateColumns from './columns';
import { clientsDataSelector } from 'redux/selectors';
import { getData, resetState } from 'redux/slices/dataSlice';

const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

function Table({ handlers }) {
  const dispatch = useDispatch();
  const dataStatus = useSelector(dataStatusSelector);
  const clientsData = useSelector(clientsDataSelector);

  const [pageSize, setPageSize] = useState(10);
  const columns = generateColumns(handlers);
  useEffect(() => {
    if (dataStatus === STATUS.idle) {
      dispatch(getData());
    }
  }, [dispatch, dataStatus]);



  const handleRetry = () => {
    dispatch(resetState());
    dispatch(getData());
  };

  let content;

  switch (dataStatus) {
    case STATUS.idle:
      content = <LimitedBackdropLoading />;
      break;
    case STATUS.pending:
      content = <LimitedBackdropLoading />;
      break;
    case STATUS.error:
      content = <TableError handleRetry={handleRetry} />;
      break;
    case STATUS.success:
      content = (
        <DataGrid
          NoRowsOverlay={<div>Sin datos</div>}
          columns={columns}
          rows={clientsData}
          density="standard"
          pageSize={pageSize}
          rowsPerPageOptions={[10, 20, 50, 100]}
          checkboxSelection={false}
          columnBuffer={0}
          disableSelectionOnClick={true}
          autoHeight
          autoPageSize={false}
          disableColumnFilter={true}
          loading={dataStatus === STATUS.pending ? true : false}
          onPageSizeChange={(pageSize) => setPageSize(pageSize)}
          paginationMode="client"
          disableColumnSelector
          componentsProps={{
            pagination: {
              labelRowsPerPage: 'Filas por página'
            }
          }}
          localeText={tableLocaleText}
        />
      );
      break;
    default:
      content = null;
      break;
  }
  return <TableContainer>{content}</TableContainer>;
}

export default React.memo(Table);
